<template>
  <p class="sub-label" :class="isAbsolute ? 'is-absolute' : ''">
    <span class="is-flex is-align-items-center">
      <i v-if="!hideIcon" class="icon cls cls-information-circle" />
      {{ label }}
    </span>
  </p>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormSubLabel',
  props: {
    label: { type: String, required: true },
    isAbsolute: { type: Boolean, default: true },
    hideIcon: { type: Boolean, default: true }
  }
};
</script>

<style scoped>
p.sub-label {
  line-height: 1.25;
  font-size: var(--ce-12px);
  color: var(--ce-grey-dark);
}
</style>
